<template>
  <div class="flex items-center z-[70]">
    <!-- Unified Pill Group -->
    <div
      class="flex items-center bg-muted/60 dark:bg-muted rounded-full p-1 lg:p-1 shadow-sm space-x-0.5 lg:space-x-1 mt-1"
    >
      <!-- Notes Unit: Add + List -->
      <div
        class="flex items-center rounded-full p-0.5 lg:p-1 space-x-0.5 lg:space-x-1 transition-colors"
        :class="[showNotes ? 'bg-[#404040]' : 'bg-gray-200/50 dark:bg-black/20']"
      >
        <button
          @click="$emit('add-note')"
          class="w-6 h-6 lg:w-8 lg:h-8 flex items-center justify-center rounded-full dark:hover:bg-card hover:shadow-sm transition-all focus:outline-none"
          title="Add Note"
        >
          <Plus
            class="w-4 h-4 lg:w-5 lg:h-5"
            :class="[showNotes ? 'text-white' : 'text-gray-700 dark:text-foreground']"
          />
        </button>

        <button
          @click="$emit('toggle-notes')"
          class="w-6 h-6 lg:w-8 lg:h-8 flex items-center justify-center rounded-full transition-all focus:outline-none"
          :class="[
            showNotes 
              ? 'bg-black text-white shadow-lg' 
              : 'text-foreground bg-gray-200 dark:bg-black/20'
          ]"
          title="Toggle Notes"
        >
          <svg
            class="w-5 h-5 lg:w-5 lg:h-5"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_23808_43751"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <path d="M24 0H0V24H24V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_23808_43751)">
              <path
                d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 2 2 9 2H14"
                stroke="currentColor"
                stroke-opacity="0.9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
                stroke="currentColor"
                stroke-opacity="0.9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 13H13"
                stroke="currentColor"
                stroke-opacity="0.9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 17H11"
                stroke="currentColor"
                stroke-opacity="0.9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </button>
      </div>

      <button
        @click="$emit('toggle-info')"
        class="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-full transition-all focus:outline-none"
        :class="[
          showInfo 
            ? 'bg-black text-white shadow-lg' 
            : 'text-foreground hover:bg-gray-200 dark:hover:bg-card'
        ]"
        title="Info"
      >
        <Info class="w-4 h-4 lg:w-5 lg:h-5" />
      </button>

      <button
        @click="$emit('toggle-modules')"
        class="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-full transition-all focus:outline-none"
        :class="[
          showModules 
            ? 'bg-black text-white shadow-lg' 
            : 'text-foreground hover:bg-gray-200 dark:hover:bg-card'
        ]"
        title="Modules"
      >
        <List class="w-4 h-4 lg:w-5 lg:h-5" />
      </button>

      <button
        @click="$emit('toggle-users')"
        class="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-full text-foreground transition-all focus:outline-none hover:bg-gray-200 dark:hover:bg-card"
        title="Community"
      >
        <Users class="w-4 h-4 lg:w-5 lg:h-5" />
      </button>
    </div>
  </div>
</template>

<script>
import { Plus, Info, List, Users } from "lucide-vue-next";

export default {
  name: "ActionToolbar",
  components: {
    Plus,
    // FileText,
    Info,
    List,
    Users,
  },
  props: {
    showNotes: {
      type: Boolean,
      default: false,
    },
    showInfo: {
      type: Boolean,
      default: false,
    },
    showModules: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "add-note",
    "toggle-notes",
    "toggle-info",
    "toggle-modules",
    "toggle-users",
  ],
};
</script>
